function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Field } from 'formik';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import GenericFormElement from '../GenericFormElement';
import { useExtendedFormikContext } from '../FormikWrapper';
import './style.scss';
var Radio = function Radio(props) {
  var className = props.className,
    disabled = props.disabled,
    _onChange = props.onChange,
    required = props.required;
  return /*#__PURE__*/React.createElement(Field, {
    name: props.name,
    validate: props.validate,
    required: required
  }, function (_ref) {
    var field = _ref.field,
      form = _ref.form;
    var name = "".concat(props.name, "--").concat(props.value);
    var classes = c('WebformRadios__radio__input', {
      'icon-before': true,
      'icon-radio': true,
      // These double equals instead of triple equals are on purpose.
      // JavaScript object keys are always strings even though they may be
      // represented as numbers.
      /* eslint-disable */
      'icon-variant-0': !(field.value && field.value == props.value),
      'icon-variant-1': field.value && field.value == props.value,
      /* eslint-enable */
      'disabled': disabled
    });
    if (props.value === '__other__') {
      var inputClasses = c({
        hidden: field.value !== '__other__'
      });
      return /*#__PURE__*/React.createElement("label", {
        htmlFor: name,
        className: classes
      }, /*#__PURE__*/React.createElement("input", _extends({}, field, {
        type: "radio",
        id: name,
        value: props.value,
        disabled: disabled,
        className: className,
        required: required,
        onChange: function onChange(event) {
          if (_onChange) {
            _onChange(props.value);
          }
          field.onChange(event);
        }
      })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, props.otherLabel ? props.otherLabel : props.label), props.description && /*#__PURE__*/React.createElement("span", null, props.description)), /*#__PURE__*/React.createElement("textarea", {
        placeholder: props.otherPlaceholder,
        className: inputClasses,
        onChange: function onChange(e) {
          form.setFieldValue("".concat(props.name, "--other"), e.target.value);
        }
      }));
    }
    return /*#__PURE__*/React.createElement("label", {
      htmlFor: name,
      className: classes
    }, /*#__PURE__*/React.createElement("input", _extends({}, field, {
      type: "radio",
      id: name,
      value: props.value,
      disabled: disabled,
      className: className,
      required: required,
      onChange: function onChange(event) {
        if (_onChange) {
          _onChange(props.value);
        }
        field.onChange(event);
      }
    })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, props.label), props.description && /*#__PURE__*/React.createElement("span", null, props.description)));
  });
};
var RadioButtons = function RadioButtons(props) {
  var title = props.title,
    required = props.required,
    description = props.description,
    placeholder = props.placeholder,
    fieldName = props.fieldName,
    validation = props.validation,
    type = props.type,
    options = props.options,
    _props$descriptions = props.descriptions,
    descriptions = _props$descriptions === void 0 ? {} : _props$descriptions,
    className = props.className,
    wrapperClassName = props.wrapperClassName,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    otherLabel = props.otherLabel,
    otherPlaceholder = props.otherPlaceholder,
    onChange = props.onChange,
    includeFieldSet = props.includeFieldSet;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useExtendedFormikCon = useExtendedFormikContext(),
    errors = _useExtendedFormikCon.errors,
    touched = _useExtendedFormikCon.touched,
    displayRequiredIndicator = _useExtendedFormikCon.displayRequiredIndicator;
  var isTouched = touched[fieldName];
  var error = errors[fieldName];
  var errorId = "".concat(props.fieldName, "--error");
  var descriptionId = "".concat(props.fieldName, "--description");
  var handleValidation = function handleValidation(value) {
    if (validation) {
      return validation(value);
    }
    if (required && !value) {
      return t(['webform.components.radio_buttons.required', 'webform.required', 'webform_required']);
    }
  };
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: c('RadioButtons', wrapperClassName),
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: isTouched,
    error: error,
    errorId: errorId,
    descriptionId: descriptionId,
    displayRequiredIndicator: displayRequiredIndicator,
    includeFieldSet: includeFieldSet
  }, Object.keys(options).map(function (item) {
    var label = _typeof(options[item]) === 'object' ? options[item].label : options[item];
    var value = _typeof(options[item]) === 'object' ? options[item].value : item;
    var optionDisabled = disabled || _typeof(options[item]) === 'object' && options[item].disabled;
    var description = descriptions[value] || _typeof(options[item]) === 'object' && options[item].description || null;
    return /*#__PURE__*/React.createElement(Radio, {
      key: value,
      label: label,
      description: description,
      className: c(className, {
        'error': error && touched
      }),
      name: fieldName,
      type: type || 'text',
      value: value,
      placeholder: placeholder,
      validate: handleValidation,
      otherLabel: otherLabel,
      otherPlaceholder: otherPlaceholder,
      disabled: optionDisabled,
      onChange: onChange,
      errorId: errorId,
      error: error,
      isTouched: isTouched,
      required: required
    });
  }));
};
export default RadioButtons;